import setActiveMenuItem from "../common/functions/setActiveMenuItem";
import initializeSidebarScrollSpy from "../common/functions/initializeSidebarScrollSpy";
import { stickMenuBar } from "../common/functions/others";

// NOTE: jQuery 3.x では $('selector').ready() がセレクタを無視して全ページで発火するため、
// $(function(){}) + 明示的なページガードに変更する
$(() => {
  if (!$("body.reg_users.show.pc").length) return;
  setActiveMenuItem();
  $(".jsSticky").stick_in_parent({ offset_top: 50 });
  initializeSidebarScrollSpy();
  stickMenuBar(".usersWrapper");
});

$(() => {
  if (!$("body.reg_users.show_articles.pc").length) return;
  setActiveMenuItem();
  stickMenuBar(".usersWrapper");
});
